export default __webpack_public_path__ + "media/devops_opportunity3_icon.3b178b469879b817f19feeee56473098.svg";